import React from 'react';
import clsx from 'clsx';
import { Colors } from '@common/tokens';

export type StepStatusType = 'done' | 'current' | 'pending';

/** Green check when done, pulsing dot when current, muted dot when pending. */
export function StepIndicator({ status }: { status: StepStatusType }) {
  return (
    <>
      {status === 'done' ? (
        <div className="wk-full-screen-loading-grid__check" />
      ) : (
        <div
          className={clsx('wk-full-screen-loading-grid__dot', {
            'wk-full-screen-loading-grid__dot--active': status === 'current',
          })}
        />
      )}

      <style jsx>{`
        .wk-full-screen-loading-grid__dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: ${Colors.steel};
          transition:
            background 0.4s ease,
            transform 0.4s ease;
        }
        .wk-full-screen-loading-grid__dot--active {
          background: ${Colors.elm};
          animation: pulse 1.4s ease-in-out infinite;
        }
        .wk-full-screen-loading-grid__check {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: ${Colors.grass};
          transition: background 0.3s ease;
        }
        @keyframes pulse {
          0%,
          100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(2);
            opacity: 0.2;
          }
        }
      `}</style>
    </>
  );
}
